const personType = {
    name: "PersonType",
    items: {
        PROD: {
            value: 1,
            text: "Producer",
            name: "PROD"
        },
        VET: {
            value: 2,
            text: "Veterinarian",
            name: "VET"
        },
        HRD: {
            value: 3,
            text: "Herdsman",
            name: "HRD"
        },
        NUT: {
            value: 4,
            text: "Nutritionist",
            name: "NUT"
        },
        BRDR: {
            value: 5,
            text: "Breeder",
            name: "BRDR"
        },
        OTH: {
            value: 6,
            text: "Other",
            name: "OTH"
        }
    }
}
export const PersonType = personType;